/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem, Spinner } from "reactstrap";
import BaseService from "../../services/baseService";
import { actions as actionsSite } from "../../redux/actions/site";
import { actionsDefaultCrud } from "../../utils/utils";
import BaseActions from "../../components/crud/baseActions";
import Crud from "../../components/crud";
import { datetime2Front } from "../../utils/converts";
import ButtonTip from "../../components/buttonTip";
import { OPERATOR_CONTAINS, OPERATOR_EQ, OPERATOR_NOT_CONTAINS, setSearchValue, parseDataSearch } from "../../config/search";
import ModalApprove from "./modalApprove";
import ModalReprove from "./modalReprove";
import ModalSetResult from "./modalSetResult";
import ModalFinalizeWithoutResult from "./modalFinalizeWithoutResult";

const GerenciarConsultasOndemand = () => {
  const profile = useSelector((state) => state.auth.profile);
  const dispatch = useDispatch();
  const baseService = new BaseService("ondemand-log-query");
  const baseActions = new BaseActions(dispatch, actionsSite, baseService, profile);
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [skip, setSkip] = useState(0);
  const [limit, setLimit] = useState(50);
  const [sort, setSort] = useState("-startAt");
  const [dataSearch, setDataSearch] = useState([]);
  const [columns, setColumns] = useState([]);
  const [configSearch, setConfigSearch] = useState([]);

  const getListagem = async ({ skip, limit, search }) => {
    let endpoint = `${baseService.route}/search-grid?skip=${skip}&limit=${limit}&populate_ondemandQuery&populate_user`;
    if (sort) {
      endpoint += `&sort=${sort}`;
    }
    search = search.concat(dataSearch);

    const _dataSearch = parseDataSearch(search);
    const res = await baseService._post(endpoint, _dataSearch);
    return res;
  };

  const preSetDataSearch = () => {
    const _dataSearch = [];
    if (!baseActions.isRootAdm()) {
      _dataSearch.push(setSearchValue('clientOwner', OPERATOR_EQ, profile.client._id));
    }
    setDataSearch(_dataSearch);
  }

  useEffect(() => {
    const run = async () => {
      setLoading(true);
      preSetDataSearch();

      if (profile) {
        let _columns = [
          { label: "Produto", field: "ondemandQuery.name" },
          { label: "Usuário", field: "user.name" },
          { label: "Pesquisou por", field: "input", convert: getQueryInputs },
          { label: "Data", field: "startAt", convert: datetime2Front },
          { label: "Status", field: "status"},
        ];

        let _configSearch = {
          enableSearch: true,
          attributes: [
            { label: "Produto", field: "queryName", operators: [OPERATOR_CONTAINS, OPERATOR_NOT_CONTAINS] },
          ],
          dataSearch,
          setDataSearch,
        };

        setColumns(_columns);
        setConfigSearch(_configSearch);

        setLoading(false)
      }
    };
    window.scrollTo(0, 0);
    run();
  }, [profile]);

  const getQueryInputs = (input) => {
    const inputs = [];
    for (const chave in input) {
      if (input.hasOwnProperty(chave)) {
        inputs.push(`${chave.toUpperCase()} = ${input[chave]}`);
      }
    }

    return inputs.join(", ");
  };

  const ButtonApprove = ({ row, callback, afterCallback }) => {
    if (row.status !== "Aguardando Aprovação") {
      return <></>
    }

    return (
      <ButtonTip
        className="btn-action rounded"
        type="button"
        size="sm"
        color="info"
        id={"Tooltip-approve" + row._id}
        tooltipText="Aprovar"
        onClick={() => callback(row, afterCallback)}
        tooltipDirection="top"
      >
        <i className="fa-solid fa-thumbs-up"></i>
      </ButtonTip>
    );
  };

  const openModalApprove = (row, afterCallback) => {
    const configModal = {
      component: <ModalApprove row={row}/>,
      title: 'Atenção',
    };
    dispatch(actionsSite.setModal(configModal));
  }

  const ButtonReprove = ({ row, callback, afterCallback }) => {
    if (row.status !== "Aguardando Aprovação") {
      return <></>
    }

    return (
      <ButtonTip
        className="btn-action rounded"
        type="button"
        size="sm"
        color="danger"
        id={"Tooltip-reprove" + row._id}
        tooltipText="Reprovar"
        onClick={() => callback(row, afterCallback)}
        tooltipDirection="top"
      >
        <i className="fa-solid fa-thumbs-down"></i>
      </ButtonTip>
    );
  };

  const openModalReprove = async (row, afterCallback) => {
    const configModal = {
      title: 'Insira o motivo da recusa',
      component: <ModalReprove row={row}/>
    };
    dispatch(actionsSite.setModal(configModal));
  }

  const ButtonSetResult = ({ row, callback, afterCallback }) => {
    if ((row.status !== "Processando" && row.status !== "Finalizado") || row.reasonForApproveWithoutResult) {
      return <></>
    }

    return (
      <ButtonTip
        className="btn-action rounded"
        type="button"
        size="sm"
        color="warning"
        id={"Tooltip-approve" + row._id}
        tooltipText={row.status === "Finalizado" ? "Complementar resultado" : "Inputar resultado"}
        onClick={() => callback(row, afterCallback)}
        tooltipDirection="top"
      >
        <i className="fa-solid fa-arrow-right-to-bracket"></i>
      </ButtonTip>
    );
  };

  const openModalSetResult = (row, afterCallback) => {
    const configModal = {
      component: <ModalSetResult row={row}/>,
      title: 'Adicionar Itens',
      size:'modal900'
    };
    dispatch(actionsSite.setModal(configModal));
  }

  const ButtonFinalizeWithoutResult = ({ row, callback, afterCallback }) => {
    if (row.status !== "Processando") {
      return <></>
    }

    return (
      <ButtonTip
        className="btn-action rounded"
        type="button"
        size="sm"
        color="secondary"
        id={"Tooltip-finalize-without-result" + row._id}
        tooltipText="Finalizar sem resultado"
        onClick={() => callback(row, afterCallback)}
        tooltipDirection="top"
      >
        <i className="fa-solid fa-ban"></i>
      </ButtonTip>
    );
  };

  const openModalFinalizeWithoutResult = async (row, afterCallback) => {
    const configModal = {
      title: 'Insira o motivo para finalização sem arquivos',
      component: <ModalFinalizeWithoutResult row={row}/>
    };
    dispatch(actionsSite.setModal(configModal));
  }

  const actions = [...actionsDefaultCrud];
  const customActions = [
    {
      action: "openModalApprove",
      enable: true,
      visibleInCrud: true,
      component: ButtonApprove,
    },
    {
      action: "openModalReprove",
      enable: true,
      visibleInCrud: true,
      component: ButtonReprove,
    },
    {
      action: "openModalSetResult",
      enable: true,
      visibleInCrud: true,
      component: ButtonSetResult,
    },
    {
      action: "openModalFinalizeWithoutResult",
      enable: true,
      visibleInCrud: true,
      component: ButtonFinalizeWithoutResult,
    },
  ];

  baseActions.setCustomActions(actions, customActions);

	//Configura callbacks
	(() => {
      const _toggle = actions.find((a) => a.action === "toggle");
      const _edit = actions.find((a) => a.action === "edit");
      const _view = actions.find((a) => a.action === "view");
      const _create = actions.find((a) => a.action === "create");
      const _delete = actions.find((a) => a.action === "delete");
      const _approve = actions.find((a) => a.action === "openModalApprove");
      const _reprove = actions.find((a) => a.action === "openModalReprove");
      const _setResult = actions.find((a) => a.action === "openModalSetResult");
      const _finalizeWithoutResult = actions.find((a) => a.action === "openModalFinalizeWithoutResult");

      if (_toggle) _toggle.enable = false;
      if (_edit) _edit.enable = false;
      if (_view) _view.enable = false;
      if (_create) _create.enable = true;
      if (_delete) _delete.enable = false;

      if (_approve) _approve.callback = openModalApprove;
      if (_reprove) _reprove.callback = openModalReprove;
      if (_setResult) _setResult.callback = openModalSetResult;
      if (_finalizeWithoutResult) _finalizeWithoutResult.callback = openModalFinalizeWithoutResult;
    }
  )();

  return (
    <div className="consultas">
      <Breadcrumb>
        <BreadcrumbItem>
          <Link to="/">Dashboard</Link>
        </BreadcrumbItem>
        {params.id && (
          <BreadcrumbItem>
            <Link to="/historico-consultas-ondemand">Consultas Ondemand</Link>
          </BreadcrumbItem>
        )}
        <BreadcrumbItem active>{params.id ? "Detalhe da consulta" : "Consultas Ondemand"}</BreadcrumbItem>
      </Breadcrumb>

      {loading ? (
        <div className="text-center">
          <Spinner color="danger" />
        </div>
      ) : (
        <>
          {!params.id && (
            <Crud
              getList={getListagem}
              recordsPerPage={limit}
              config={{ columns, actions }}
              configSearch={configSearch}
              setSkip={setSkip}
              skip={skip}
              setLimit={setLimit}
              limit={limit}
              setSort={setSort}
              sort={sort}
              baseRoute="/consultas-ondemand/gerenciar"
            />
          )}
        </>
      )}
    </div>
  );
};

export default GerenciarConsultasOndemand;